export const textToImageConvertor = (
  text: string,
  fontSize = 30,
  fontFamily = "cursive"
) => {
  const canvas = document.createElement("canvas");
  const context = canvas.getContext("2d");

  // Set canvas size based on text length
  canvas.width = text?.length * fontSize * 0.8;
  canvas.height = fontSize * 1.5;

  if (context) {
    context.font = `${fontSize}px ${fontFamily}`;
    context.fillStyle = "black";
    context.fillText(text, 0, fontSize);
  }

  return canvas.toDataURL("image/png");
};
